import React from "react";
import {
  ContainerIframe,
  ContainerReports,
} from "./ReportsICEContainer.styled";

const ReportsICEContainer = () => {
  const iframe =
    '<iframe title="Quick Assist" src="https://app.powerbi.com/reportEmbed?reportId=0224cacb-7339-4ac8-a048-53b6069f5dcb&autoAuth=true&ctid=638fcbaf-ba4c-43e1-adae-5475c970fe10" style="border: 0px; overflow: hidden; width: 100%; height: 100%; min-height: 610px;"></iframe>';

  return (
    <ContainerReports>
      <ContainerIframe
        contentEditable="true"
        dangerouslySetInnerHTML={{ __html: iframe }}
      ></ContainerIframe>
    </ContainerReports>
  );
};

export default ReportsICEContainer;
